// extracted by mini-css-extract-plugin
export default {"icon":"QI_ns2e7lnDXm9fv3DQI","root":"P3QUv5ZBxIDGtrR1No8J","open":"LTQsvXzOVrHWs8zwBlup","small":"pvV9L6Y_TqUegUE1lYE5"};